/**
 * Created by baijing on 2018/5/29.
 */

var route = {
    path : '/activeSubaccount',
    getComponent(nextState, cb) {
        require.ensure([], (require) => {
            cb(null, require('../pc/ActiveSubaccount.jsx').default)
        }, 'activeSubaccount')
    }
}


export default route;


// WEBPACK FOOTER //
// ./src/routes/activeSubaccount.js